export default __webpack_public_path__ + "static/media/appleStore.5d74d813.svg";